<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
  beforeCreate(){
      let entryLocation = window.location.pathname;
      let entryLocationSearch = window.location.search;
      this.$gtm.push({
        event: 'EntryLocationSetGame',
        entryLocation: entryLocation + entryLocationSearch,
      })
    },
  }
  </script>

<style lang="scss">
@import "./styles/main";
</style>
